export enum API_STATUS {
  LOADING = 'loading',
  ERROR = 'error',
  DONE = 'done'
}
